import { getAssessments, putAssessment, postAssessment } from '../api';
import { dispatchGrassError } from './index';
import * as actionTypes from './actionTypes';

export function getAssessmentsList () {
  return dispatch => getAssessments()
    .then(({ data }) => {
      dispatch({ type: actionTypes.GET_ASSESSMENTS_SUCCESS, data });
      return data;
    })
    .catch(error => dispatchGrassError(error, dispatch));
}

export function editAssessment (id, formData) {
  return dispatch => putAssessment(id, formData)
    .then(({ data }) => data)
    .catch(error => dispatchGrassError(error, dispatch));
}

export function createAssessment (formData) {
  return dispatch => postAssessment(formData)
    .then(({ data }) => data)
    .catch(error => dispatchGrassError(error, dispatch));
}



// WEBPACK FOOTER //
// ./src/actions/assessments.js